import { render } from "./propertiesEdit.vue?vue&type=template&id=100721b2"
import script from "./propertiesEdit.vue?vue&type=script&lang=js"
export * from "./propertiesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__